/**
 * Fleet Directory · Master Armada Roster
 *
 * Single source of truth for every Sovereign Node in the EIGOO empire.
 * Director directive 2026.06 · Strike #25.
 *
 * To dock a new node: append to the appropriate category.
 *   status: "live"     → renders as gold-bordered clickable card
 *   status: "pending"  → renders muted/greyed with "COMING SOON" badge
 *
 * Categories render in the order defined in FLEET_DIRECTORY below
 * (Primary first → Operations → Rescue → Pending).
 */

export const FLEET_DIRECTORY = [
    {
        id: "primary",
        title: "Primary Nodes",
        subtitle: "The Six Sovereign Tracks",
        accent: "#C9A227",
        nodes: [
            { slug: "finance",    label: "Finance",    url: "https://tax.eigooinc.net",        tagline: "Trade · Capital · Treasury", status: "live" },
            { slug: "security",   label: "Security",   url: "https://auth.eigooinc.net",       tagline: "TechOps · Vault · Audits",   status: "live" },
            { slug: "artisan",    label: "Artisan",    url: "https://islandgold.eigooinc.net", tagline: "Island Gold · Craft",         status: "live" },
            { slug: "lifestyle",  label: "Lifestyle",  url: "https://hi.eigooinc.net",         tagline: "Hi · Sovereign Living",       status: "live" },
            { slug: "music",      label: "Music",      url: "https://music.eigooinc.net",      tagline: "Vocal Command · Sound",       status: "live" },
            { slug: "contest",    label: "Contest",    url: "https://siren.eigooinc.net",      tagline: "Siren · Arena",               status: "live" },
        ],
    },
    {
        id: "operations",
        title: "Operations Nodes",
        subtitle: "Fleet Command & Signal Infrastructure",
        accent: "#00E5FF",
        nodes: [
            { slug: "lead",   label: "Lead Command", url: "https://lead.eigooinc.net",   tagline: "Pipeline guardian · CRM",        status: "live" },
            { slug: "signal", label: "Signal Tower", url: "https://signal.eigooinc.net", tagline: "Broadcast · Comms relay",        status: "live" },
        ],
    },
    {
        id: "rescue",
        title: "Rescue Nodes",
        subtitle: "Sovereign Humanitarian Operations",
        accent: "#E8C56C",
        nodes: [
            { slug: "nessa",          label: "Nessa",            url: "https://nessa.eigooinc.net",          tagline: "Rescue ops · Sovereign care",   status: "live" },
            { slug: "mercyproperties",label: "Mercy Properties", url: "https://mercyproperties.eigooinc.net",tagline: "Sovereign housing dispatch",    status: "live" },
        ],
    },
    {
        id: "pending",
        title: "Provisioning Queue",
        subtitle: "Arriving Hulls · Coming Soon",
        accent: "#5C7894",
        nodes: [
            { slug: "trade",     label: "Trade",     url: "https://trade.eigooinc.net",     tagline: "Markets desk · arriving",     status: "pending" },
            { slug: "sports",    label: "Sports",    url: "https://sports.eigooinc.net",    tagline: "Sports intelligence · arriving", status: "pending" },
            { slug: "wayfinder", label: "Wayfinder", url: "https://wayfinder.eigooinc.net", tagline: "Hardware provisioning · arriving", status: "pending" },
        ],
    },
];
